import { messages } from "../../lib/messages";

interface SearchBarProps {
  value: string;
  onChange(value: string): void;
}

/**
 * SearchBar — контролируемое поле поиска каталога (docs/07-miniapp-ux.md §2.2).
 * Debounce и порог в 2 символа — забота вызывающей страницы, не этого компонента.
 */
export function SearchBar({ value, onChange }: SearchBarProps) {
  return (
    <div className="relative px-4">
      <input
        type="search"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={messages.searchPlaceholder}
        className="w-full rounded-card bg-surface px-4 py-2 text-text placeholder:text-hint"
      />
      {value ? (
        <button
          type="button"
          aria-label="Очистить поиск"
          onClick={() => onChange("")}
          className="absolute right-6 top-1/2 -translate-y-1/2 text-hint"
        >
          ×
        </button>
      ) : null}
    </div>
  );
}
